module.exports = __webpack_public_path__ + "static/media/photo_16.53ac9756.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/gallery/photo_16.jpg
// module id = 1649
// module chunks = 0